<div class="row" data-cy="patient-find-main-container">
  <h5 class="main-title" data-cy="patient-find-title">Find a patient</h5>
  <div class="error-message" *ngIf="error" data-cy="patient-find-error-message">{{ error }}</div>
</div>
<div class="row" data-cy="patient-find-search-container">
  <div class="input-group mb-3" data-cy="patient-find-input-group">
    <div class="input-group-prepend" data-cy="patient-find-search-label-container">
      <span class="input-group-text" id="idFind" data-cy="patient-find-search-label">Search for: </span>
    </div>
    <input type="text" class="form-control" [(ngModel)]="searchCriteria" placeholder="Name or phone number"
           aria-label="SerchCriteria" aria-describedby="idFind" (keyup)="onFindTextChange($event)" data-cy="patient-find-search-input">
    <div class="input-group-append" data-cy="patient-find-clear-button-container">
      <button class="btn btn-outline-info" (click)="onClickButtonClear()" data-cy="patient-find-clear-button">X</button>
    </div>
  </div>
</div>

<div class="row" data-cy="patient-find-results-container">
  <div class="col-12" data-cy="patient-find-results-column">
    <div class="patient-list" *ngIf="!isSearching" data-cy="patient-find-list">
      <div class="list-group" *ngFor="let patient of patientList" data-cy="patient-find-list-item-group">
        <button type="button" class="list-group-item list-group-item-action"
                (click)="onClickButtonPatientSelected(patient)" data-cy="patient-find-list-item-button">
          <b data-cy="patient-find-patient-name">{{ patient.FirstName }} {{ patient.MidName }} {{ patient.LastName }}</b>
          <span data-cy="patient-find-patient-address">{{ patient.HomeAddress }}</span>
          <mat-icon class="call-icon" *ngIf="patient.Phone" data-cy="patient-find-phone-icon">call</mat-icon>
          <span data-cy="patient-find-patient-phone">{{ patient.Phone | formatPhone:'US' }}</span>
        </button>
      </div>
    </div>
    <div class="spinner-container" *ngIf="isSearching" data-cy="patient-find-loading-spinner">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
  </div>
</div>
